var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgCheckmark = function SvgCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 18 18",
    fill: "none"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.948 9.047a.524.524 0 00-.785 0 .643.643 0 000 .855l2.683 2.92c.217.238.57.237.787 0l6.205-6.79a.643.643 0 00-.002-.856.524.524 0 00-.785.002L7.238 11.54l-2.29-2.492z",
    fill: "currentColor",
    stroke: "currentColor"
  })));
};

export default SvgCheckmark;